import { AVATAR_SIDE, MAX_PHOTO_UPLOAD_BYTES, photoFileProblem, squareCrop } from './photo';

const QUALITIES = [0.88, 0.8, 0.7, 0.6];

function toJpeg(canvas: HTMLCanvasElement, quality: number): Promise<Blob | null> {
  return new Promise((resolve) => canvas.toBlob(resolve, 'image/jpeg', quality));
}

async function loadImage(file: File): Promise<HTMLImageElement> {
  const url = URL.createObjectURL(file);
  try {
    const image = new Image();
    image.src = url;
    await image.decode();
    return image;
  } catch {
    throw new Error('The file could not be read as an image.');
  } finally {
    URL.revokeObjectURL(url);
  }
}

export async function prepareAvatarUpload(file: File): Promise<Blob> {
  const problem = photoFileProblem(file.type, file.size);
  if (problem) {
    throw new Error(problem);
  }
  const image = await loadImage(file);
  const { sx, sy, side } = squareCrop(image.naturalWidth, image.naturalHeight);
  const canvas = document.createElement('canvas');
  canvas.width = AVATAR_SIDE;
  canvas.height = AVATAR_SIDE;
  const context = canvas.getContext('2d');
  if (!context) {
    throw new Error('Your browser cannot process images.');
  }
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, AVATAR_SIDE, AVATAR_SIDE);
  context.drawImage(image, sx, sy, side, side, 0, 0, AVATAR_SIDE, AVATAR_SIDE);
  for (const quality of QUALITIES) {
    const blob = await toJpeg(canvas, quality);
    if (blob && blob.size <= MAX_PHOTO_UPLOAD_BYTES) {
      return blob;
    }
  }
  throw new Error('The image could not be compressed below 1 MB.');
}
